import { render, staticRenderFns } from "./like-post-button.vue?vue&type=template&id=58a4eafb&"
import script from "./like-post-button.vue?vue&type=script&lang=js&"
export * from "./like-post-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports